import { observable } from 'mobx';

const INITIALIZED_LOCALE = observable.box('de-DE');

export const initializeLocale = (locale?: string) => {
    INITIALIZED_LOCALE.set(locale?.replace('_', '-') || 'de-DE');
};

export const getInitializedLocale = () => INITIALIZED_LOCALE.get();
